export default "__VITE_ASSET__6e711ae1__"